export default {
    methods: {
        getGroupError(groupId, field) {
            const groupErrors = this.validation.errors.groups[groupId]
            if (!groupErrors || !groupErrors[field] || groupErrors[field].length === 0) {
                return ''
            }
            return groupErrors[field][0]
        },
        getMaterialWeightError(groupId) {
            const groupErrors = this.validation.errors.groups[groupId]
            if (!groupErrors) {
                return ''
            }
            return groupErrors.materialWeightFrom[0] || groupErrors.materialWeightTo[0] || ''
        },
        getSubstanceError(groupId, index, field) {
            const groupErrors = this.validation.errors.groups[groupId]
            if (!groupErrors || !groupErrors.substances[index] || !groupErrors.substances[index][field]) {
                return ''
            }
            return groupErrors.substances[index][field][0] || ''
        },
        getSubstanceWeightError(groupId, index) {
            const groupErrors = this.validation.errors.groups[groupId]
            if (!groupErrors || !groupErrors.substances[index]) {
                return ''
            }
            return groupErrors.substances[index].weightFrom[0] || groupErrors.substances[index].weightTo[0] || ''
        },
        getMaterialWarning(groupId) {
            if (this.validation.warnings.groups[groupId]) {
                return this.$t('Component(FMDEditor):warning-substances-sum-exceeds-100')
            }
            return ''
        },
    },
}
